export const queryStringArray = (name: string, array: any[]) => {
  if (!array || array.length === 0) {
    return ``;
  }
  let toReturn = '';
  array.forEach((val) => {
    toReturn += `${name}=${val}&`;
  });
  return toReturn;
};

export const queryStringParam = (name: string, value: string | number | undefined) => {
  if (!value) {
    return `${name}=`;
  }
  return `${name}=${value}`;
};

export const roots = {
  activityNew: (part: string, id: number | undefined) => {
    return id ? `/api/activities/${id}/${part}` : `/api/activities/${part}`;
  },
  folioNew: (part: string, id: number | undefined) => {
    return id ? `/api/folio/${id}/${part}` : `/api/folio/${part}`;
  },
  selectOption: '/api/selectoption'
};
